import React from "react";
import { NavLink } from "react-router-dom";
import AlertCard from "./panel/alertCard";
import BuyCouldPhone from "./vop/buyCouldPhone";
import CloudLandlinePhoneRegistration from "./vop/cloudLandlinePhoneRegistration";
import CloudPhoneFrequentlyAskedQuestions from "./vop/cloudPhoneFrequentlyAskedQuestions";
import InternetPhoneCosts from "./vop/InternetPhoneCosts";
import Maxsfone from "./vop/maxsfone";
import VirtualLandlinePhoneFeatures from "./vop/virtualLandlinePhoneFeatures";
import WhoiseVOP from "./vop/whoiseVOP";
const VOPInfo = () => {
  return (
    <div>
      <WhoiseVOP />
      <BuyCouldPhone />
      <VirtualLandlinePhoneFeatures />
      <InternetPhoneCosts />
      <CloudLandlinePhoneRegistration />
      <Maxsfone />
      <AlertCard
        color="#7FFFD4"
        header="نماینده فروش تلفن ثابت ابری شوید!"
        description={
          <div>
            اگر با کسب و کارهای نمایندگی و ریسلری تحت اینترنت آشنا باشید میدانید
            که فقط شرکت های هاستینگ(سرور) و پیامک اقدام به ارائه نمایندگی های
            ریسلر فروش مستقل میکنند و تا به این لحظه فقط در این دو حوزه هر شخصی
            میتوانست یک پنل ریسلری تهیه کرده و اقدام به فروش مستقل و کسب درآمد
            کند. در حوزه خدمات تلفن های مجازی و اینترنتی هیچ شرکتی نمایندگی فروش
            به هیچ شخصی ارائه نمیکرد و علت آن هم اینست که توانایی و دانش پیاده
            سازی زیرساخت نرم افزاری ریسلری در سامانه خود را ندارند.
            <br />
            با توجه به اینکه ما در سامانه سایه بان زیرساخت ارائه نمایندگی تا
            لایه n ام را داریم و خدمات تلفن ابری هم در همین سامانه ارائه میشود،
            توانسته ایم ارائه نمایندگی فروش تلفن ابری را نیز بدون مشکل در سامانه
            پیاده سازی کنیم و هر شرکت و حتی شخص حقیقی میتواند پنل نمایندگی فروش
            تلفن ابری را از ما تهیه کند فقط کافیست یک پنل نمایندگی پیامک سایه
            بان را تهیه کند. جهت بررسی و تهیه پنل نمایندگی و همچنین نحوه درآمد
            نمایندگی فروش تلفن ثابت اینترنتی از صفحه نمایندگی اقدام کنید.
            <div className="text-center">
              <NavLink to="/Reseller" className="btn btn-info">
                نمایندگی سایه بان
              </NavLink>
            </div>
          </div>
        }
      />
      <CloudPhoneFrequentlyAskedQuestions />
    </div>
  );
};

export default VOPInfo;
